// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"130b6673","182":"b8d2c667","317":"48bd9b7f","515":"fd66149e","643":"2f70b159","680":"9d927dff","815":"a2b2e478"}[chunkId] + ".chunk.js";
};